module.exports = __webpack_public_path__ + "static/media/IMG_0819.d33a10e6.jpg";